import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { store } from './store/store';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

/**  */

/** */

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <CookiesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </CookiesProvider>
  </Provider>
  // </React.StrictMode>
);
